import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'text-steps';

/**
 * This is the component description.
 */
const TextSteps = ({
  id,
  className: userClassName,
  style,
  items,
  title
}) => /*#__PURE__*/React.createElement("div", {
  id: id,
  className: [baseClassName, componentClassName, userClassName, 'grid'].filter(e => e).join(' '),
  style: style
}, title && /*#__PURE__*/React.createElement("p", {
  className: "title h4"
}, title), items.map((item, i) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
  className: " number h3 start-1 span-2 md-start-1 md-span-2"
}, /*#__PURE__*/React.createElement("p", null, i + 1)), /*#__PURE__*/React.createElement("div", {
  className: " description"
}, /*#__PURE__*/React.createElement("p", null, item)))));
TextSteps.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The steps to iterate
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.node
  })).isRequired,
  /**
   * The title to pass to the component
   */
  title: PropTypes.string
};
export default TextSteps;